import { COMPANY } from "@/data/site";

export const Marquee = ({ items, className = "" }) => {
  const content = items.length ? items : ["Roof Cleaning", "Render Softwashing", "Driveway Cleaning", "Gutter Clearing", "Fascia & Soffit Cleaning"];
  const loop = [...content, ...content];
  return (
    <div className={`overflow-hidden bg-[var(--bone)] border-y border-[var(--border)] py-6 ${className}`} data-testid="marquee">
      <div className="animate-marquee inline-flex items-center gap-10">
        {loop.map((t, i) => (
          <span key={i} className="inline-flex items-center gap-10">
            <span className="font-serif italic text-2xl md:text-4xl text-[var(--ink)]/80">{t}</span>
            <span className="text-[var(--oxblood)] text-xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
